<script>
  import { onMount } from "svelte";
  export let image;

  let imageFileName;
  let isProcessing = false;
  onMount(async () => {
    imageFileName = new Date().getTime();
  });

  const getMobileOS = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return "Android";
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      return "iOS";
    }

    return "Other";
  };

  /**
   * 画像付きでWebページを共有する
   */
  const share = () => {
    isProcessing = true;
    const target = document.getElementById("image");
    const imageData = new File([toBlob(target.src)], "tmp.png", {
      type: "image/png",
    });
    navigator
      .share({
        text: "美術館に絵を飾ったぞ！！\n#美術館シミュレーター",
        url: "https://museum-simulator.vercel.app/",
        files: [imageData],
      })
      .then(() => {
        console.log("Share was successful.");
        isProcessing = false;
      })
      .catch((error) => {
        console.log("Sharing failed", error);
        isProcessing = false;
      });
  };

  /**
   * Base64形式の画像データをBlobに変換する
   * @param {String} base64 Base64形式の画像データ
   * @returns {Blob} Blob形式の画像データ
   */
  const toBlob = (base64) => {
    var bin = atob(base64.replace(/^.*,/, ""));
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    // Blobを作成
    try {
      var blob = new Blob([buffer.buffer], {
        type: "image/png",
      });
    } catch (e) {
      return false;
    }
    return blob;
  };

  const save = () => {
    const dl = document.getElementById("download-link");
    dl.href = image;
    dl.download = new Date().getTime() + ".png";
  };
</script>

<div class="container">
  画像は保存ボタンから保存してください。
  {#if getMobileOS() === "Android"}
    <br />Androidユーザーの方は[シェア]ボタンから画像付きでSNS等に共有できます。
  {/if}
  <img id="image" src={image} alt={imageFileName} class="hidden" />
  <div class="controller">
    <a
      class="button button-primary"
      target="_blank"
      rel="noopener noreferrer"
      href="https://twitter.com/intent/tweet?text=%E7%BE%8E%E8%A1%93%E9%A4%A8%E3%81%AB%E7%B5%B5%E3%82%92%E9%A3%BE%E3%81%A3%E3%81%9F%E3%81%9E%EF%BC%81%EF%BC%81%0A%23%E7%BE%8E%E8%A1%93%E9%A4%A8%E3%82%B7%E3%83%9F%E3%83%A5%E3%83%AC%E3%83%BC%E3%82%BF%E3%83%BC%0Ahttps%3A%2F%2Fmuseum-simulator.vercel.app%2F"
    >
      ツイート
    </a>
    <a
      id="download-link"
      class="button button-primary"
      href=""
      download=""
      on:click={save}>保存</a
    >
    {#if getMobileOS() === "Android"}
      <button class="button-primary" on:click={share}>シェア</button>
    {/if}
  </div>
</div>

<style>
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background-color: aliceblue;
  }
  .controller {
    margin-top: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
  }

  button,
  .button {
    padding-left: 10px;
    padding-right: 10px;
  }

  #image {
    max-width: 100%;
    max-height: 62%;
  }

  .hidden {
    display: none !important;
  }

  .processing-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: rgba(64, 64, 64, 0.7);
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    color: white;
    font-size: 2rem;
  }
</style>
